export default "__VITE_ASSET__CBVb6sQZ__"